
<loader *ngIf="loader" [message]="loaderMsg" type="large"></loader>
<notification type="error" *ngIf="notification.active">
    {{notification.message}}
</notification>